import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { Status } from 'components/search/result-card/index'
import setDefaultReturn from 'lib/junior-league-utils/set-default-return'

const useStyles = makeStyles(theme => ({
  access: {
    marginBottom: theme.spacing(1),

    [theme.breakpoints.up('sm')]: {
      marginBottom: 0,
      marginRight: theme.spacing(2),
    },
  },
}))

const accessDescriptions = setDefaultReturn(
  {
    OPEN_TO_PUBLIC: null,
    CODE_REQUIRED: 'Access Code Required',
    CLUB_REQUIRED: 'Club Membership Required',
  },
  null,
)

export default function Access({ hit }) {
  const classes = useStyles()
  const description = accessDescriptions[hit.restricted_access]

  return (
    description && (
      <Status
        backgroundColor="primary.main"
        color="white"
        className={classes.access}
      >
        {description}
      </Status>
    )
  )
}
